import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface GallerySection {
  id: string;
  section_key: string;
  title_fr: string | null;
  images: string[];
  max_images: number;
  is_active: boolean;
}

export const useGallerySection = (sectionKey: string) => {
  const [data, setData] = useState<GallerySection | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data: row, error } = await supabase
      .from("photo_galleries")
      .select("id, section_key, title_fr, images, max_images, is_active")
      .eq("section_key", sectionKey)
      .maybeSingle();
    if (!error && row) {
      setData({
        ...row,
        images: Array.isArray(row.images) ? (row.images as string[]) : [],
      });
    }
    setLoading(false);
  }, [sectionKey]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const saveImages = async (images: string[]) => {
    if (!data) return;
    const { error } = await supabase
      .from("photo_galleries")
      .update({ images })
      .eq("id", data.id);
    if (!error) setData({ ...data, images });
    return !error;
  };

  return { data, loading, refetch: fetchData, saveImages };
};